export default __webpack_public_path__ + "static/media/brand.4842f8a8.jpg";